<div>
  <label class="form-label desktop_body_small">
    {{label}}
  </label>
  <span class="float-end"
        *ngIf="tooltip"
        [matTooltip]="tooltip"
    >
    <img src="assets/imgs/icones/info.svg" width="20px" alt="">
  </span>
</div>
<div class="row">
  <div class="col-12">
    <div class="switch-toggle-3" [class.disabled]="disabled">
      <input (click)="selecyType(inputUm?.value)" [value]="inputUm?.value" [id]="'valor-um-' + id"
             [checked]="tipoNumber ? parseInt(value, 0) === inputUm?.value : value === inputUm?.value"
             [disabled]="disabled"
             [name]="'acao-destacado-'+id" type="radio">
      <label class="" [for]="'valor-um-' + id"
             [class.disabled-radio]="disabled"
             onclick="">{{inputUm?.label}}</label>
      <input (click)="selecyType(inputDois?.value)" [value]="inputDois?.value" [id]="'valor-dois-' + id"
             [disabled]="disabled"
             [checked]="tipoNumber ? parseInt(value, 0) === inputDois?.value : value === inputDois?.value"
             [name]="'acao-destacado-'+id" type="radio">
      <label class="" [for]="'valor-dois-' + id"
             [class.disabled-radio]="disabled"
             onclick="">{{inputDois?.label}}</label>
      <input *ngIf="inputTres.ativo" (click)="selecyType(inputTres?.value)" [value]="inputTres?.value" [id]="'valor-tres-' + id"
             [disabled]="disabled"
             [checked]="tipoNumber ? parseInt(value, 0) === inputTres?.value : value === inputTres?.value"
             [name]="'acao-destacado-'+id" type="radio">
      <label  *ngIf="inputTres.ativo"
              [class.disabled-radio]="disabled"
              class="" [for]="'valor-tres-' + id" onclick="">{{inputTres?.label}}</label>
      <a></a>
    </div>
  </div>
</div>
<div *ngIf="invalid" class="invalid-feedback-inputs">
  <span>{{msgAlerta}}</span>
</div>
